import { Box, Container, Stack, Typography, Link as MuiLink } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function Footer() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: { xs: 3, md: 4 },
        background: `linear-gradient(180deg, #064e2a, 0%, #000 100%)`,
        color: "#fff"
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={1} alignItems="center" textAlign="center">
          <Typography
            sx={{
              fontSize: { xs: ".9rem", md: ".95rem" },
              fontWeight: 700,
              color: "#fff"
            }}
          >
            © 2026 Liga Deportiva Cantonal Mejía
          </Typography>

        </Stack>
      </Container>
    </Box>
  );
}

export default Footer;